import React, { FC, useState, useEffect, useRef } from 'react';
import TitleLabel from 'src/components/atoms/label/TitleLabel';
import './style.scss';

interface OptionProps {
  id: string;
  value: string;
}
interface Props {
  label?: string;
  select?: { checked: OptionProps; options: OptionProps[] };
  labelStyle?: React.CSSProperties;
  styleDef?: React.CSSProperties;
  boxStyleDef?: React.CSSProperties;
  optionStyleDef?: React.CSSProperties;
  status?: string;
  type?: string;
  labelType?: string;
  labelPosition?: string;
  confirmEvent?: (item: { id: string; value: string }, fieldName: string) => void;
  field?: string;
  customEvt?: any;
}

const DefaultSelect: FC<Props> = ({
  label = '',
  select,
  styleDef,
  labelStyle,
  boxStyleDef,
  optionStyleDef,
  status,
  type,
  labelType = '',
  labelPosition,
  confirmEvent,
  field,
  customEvt,
}) => {
  const chkSelectOption: any = select || {
    checked: { id: 'select', value: 'select' },
    options: [{ id: 'select', value: 'select' }],
  };

  // Ref
  const selectRef = useRef<HTMLDivElement | null>(null);
  // State
  const [selectBoxProp, setSelectBoxProp] = useState({
    active: '',
    checked: chkSelectOption.checked,
  });

  useEffect(() => {
    setSelectBoxProp({ ...selectBoxProp, checked: chkSelectOption.checked });
  }, [select]);

  // Event
  const clickViewEvent = () => {
    if (type === 'readonly') return false;
    if (type === '_disabled') return false;
    selectBoxProp.active === ''
      ? setSelectBoxProp({ ...selectBoxProp, active: '_active' })
      : setSelectBoxProp({ ...selectBoxProp, active: '' });
  };
  const clickValue = (e: React.MouseEvent, item: { id: string; value: string }) => {
    e.stopPropagation();
    setSelectBoxProp({ ...selectBoxProp, active: '', checked: item });
    if (confirmEvent) {
      if (customEvt) {
        customEvt(item, field);
      } else {
        confirmEvent(item, field || '');
      }
    }
  };

  /*
   * :: Check OutSide
   */
  const boxOutsideRef = useRef<HTMLDivElement | null>(null);
  const handleClickOutside = (event: MouseEvent) => {
    if (boxOutsideRef.current && !boxOutsideRef.current.contains(event.target as HTMLElement)) {
      if (selectRef.current && !selectRef.current.contains(event.target as HTMLElement)) {
        setSelectBoxProp({ ...selectBoxProp, active: '' });
      }
    }
  };
  useEffect(() => {
    // setSelectBoxProp({ ...selectBoxProp, checked: selectBoxProp.checked });
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [selectBoxProp.checked]);

  useEffect(() => {
    if (status === 'init') {
      setSelectBoxProp({ ...selectBoxProp, checked: chkSelectOption.checked });
    }
  }, [chkSelectOption.checked]);

  return (
    <div className={['_select_label_box_div', labelPosition].join(' ')}>
      {label !== '' ? (
        <div className={['_label_div', labelPosition].join(' ')}>
          <TitleLabel
            label={label}
            labelPosition={labelPosition}
            styleDef={labelStyle}
            type={labelType}
          />
        </div>
      ) : (
        ''
      )}
      <div className={['_select_box', type, selectBoxProp.active].join(' ')} style={boxStyleDef}>
        {/* ViewBOX */}
        <div className="_view_box" onClick={clickViewEvent} ref={selectRef} style={styleDef}>
          <div className={['_tit', selectBoxProp.checked?.id === '' ? '_none' : ''].join(' ')}>
            {selectBoxProp.checked?.value}
          </div>
          {type !== 'readonly' ? (
            <div className="_btn">
              <div className="_icon">
                {selectBoxProp.active === '_active' ? (
                  <i className="ri-arrow-drop-up-line" />
                ) : (
                  <i className="ri-arrow-drop-down-line" />
                )}
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
        {/* OptionBOX */}
        <div className="_option_box" ref={boxOutsideRef} style={optionStyleDef}>
          <div className="_option">
            {chkSelectOption.options.map((item: OptionProps, idx: number) => {
              return (
                <div className="_option_item" key={idx}>
                  {item.id !== '' ? (
                    <div className="_item" key={idx} onClick={e => clickValue(e, item)}>
                      <div className="_tit">{item.value}</div>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultSelect;
